import { render, staticRenderFns } from "./Applies.vue?vue&type=template&id=58dd2637&scoped=true"
import script from "./Applies.vue?vue&type=script&lang=js"
export * from "./Applies.vue?vue&type=script&lang=js"
import style0 from "./Applies.vue?vue&type=style&index=0&id=58dd2637&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dd2637",
  null
  
)

export default component.exports